import { parsePhoneNumberFromString } from "libphonenumber-js";

export default function (phone) {
  if (!phone) return phone;
  phone = typeof phone !== "string" ? phone.toString() : phone;
  const onlyDigits = phone.replace(/\D/g, "");
  // 0800 - tratamento especial
  if (/^0800/.test(onlyDigits)) {
    if (onlyDigits.length === 11) {
      // 0800 XXX XXXX
      return onlyDigits.replace(/(0800)(\d{3})(\d{4})/, "$1 $2 $3");
    } else if (onlyDigits.length === 12) {
      // 0800 XXXX XXXX
      return onlyDigits.replace(/(0800)(\d{4})(\d{4})/, "$1 $2 $3");
    } else {
      // fallback: só separa 0800 do resto
      return onlyDigits.replace(/(0800)(.*)/, "$1 $2");
    }
  }
  // Internacional ou nacional comum
  const phoneObj = parsePhoneNumberFromString(phone);
  if (phoneObj) {
    if (phoneObj.country === "BR") {
      // Nacional: formata para visualização padrão Brasil
      return phoneObj.formatNational();
    } else {
      // Internacional: retorna formatado internacional
      return phoneObj.formatInternational();
    }
  }
  // Se já começa com +, retorna como está
  if (typeof phone === "string" && phone.trim().startsWith("+")) {
    return phone;
  }
  return phone;
}
